"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorDrawerTab_1 = require("./EditorDrawerTab");
Object.defineProperty(exports, "EditorDrawerTab", { enumerable: true, get: function () { return EditorDrawerTab_1.default; } });
